// extracted by mini-css-extract-plugin
export default {"dragAndDropMove":"JdryvudJ_PockhU9HOlo","dragAndDropMoveItem":"lc3ZFgLrySAe7rcS2yuT","dragAndDropMoveItemAbsolute":"YXI5f6zlihwbCKbuDkyc"};